import React, { useEffect, useRef, useState } from 'react';
import navdata from "../Layout/LayoutMenuData";
import SimpleBar from "simplebar-react";
import { authServices } from 'Utils/auth/services';
import { Modal, Button } from 'react-bootstrap';
import UserDetailsModal from './Modals/marketAnalaysis/marketAnalysis';

// Custom debounce hook
const useDebouncedEffect = (effect: () => void, deps: any[], delay: number) => {
    useEffect(() => {
        const handler = setTimeout(() => effect(), delay);
        return () => clearTimeout(handler);
    }, [...deps, delay]);
};

const SearchOption = () => {
    const navData = navdata().props.children;
    const [searchTerm, setSearchTerm] = useState('');
    const [filterData, setFilterData] = useState<any[]>([]);
    const [sportData, setSportData] = useState<any[]>([]);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const dropdownRef = useRef<any>(null);
    const [showUserModal, setShowUserModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState<any>(null);

    const fetchSportData = async () => {
        try {
            const { response } = await authServices.getUserList({ user_name: searchTerm });
            const data = response?.data || [];
            setSportData(data);
            setFilterData(data);
            setDropdownVisible(true);
        } catch (error) {
            console.error("Error fetching sport data:", error);
        }
    };
  

    // Debounce fetch call
    useDebouncedEffect(() => {
        if (searchTerm.trim().length > 0) {
            fetchSportData();
        } else {
            setFilterData([]);
        }
    }, [searchTerm], 300);

    useEffect(() => {
        const searchOptions = document.getElementById("search-close-options") as HTMLElement;

        if (searchTerm.length > 0) {
            searchOptions?.classList.remove("d-none");
        } else {
            searchOptions?.classList.add("d-none");
        }

        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownVisible(false);
                setSearchTerm('');
                setFilterData([]);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [searchTerm]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newSearchTerm = event.target.value;
        setSearchTerm(newSearchTerm);
    };

    const handleCloseDropdown = () => {
        setSearchTerm('');
        setFilterData([]);
        setDropdownVisible(false);
    };

    const handleUserClick = (user: any) => {
        setSelectedUser(user);
        setShowUserModal(true);
        setDropdownVisible(false);
    };

    return (
        <React.Fragment>
            <form className="app-search d-none d-xl-flex position-relative" ref={dropdownRef}>
                <div className="position-relative">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search user..."
                        id="search-options"
                        value={searchTerm}
                        onFocus={() => setDropdownVisible(true)}
                        onChange={handleChange}
                    />
                    <span className="mdi mdi-magnify search-widget-icon"></span>
                    <span
                        onClick={handleCloseDropdown}
                        className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                        id="search-close-options"
                    ></span>
                </div>

                {dropdownVisible && (
                    <div className="dropdown-menu dropdown-menu-lg show" id="search-dropdown">
                        <SimpleBar style={{ maxHeight: "320px" }}>
                            {filterData.length > 0 ? (
                                filterData.map((user: any, index: number) => (
                                    <div
                                        key={index}
                                        className="dropdown-item notify-item"
                                        style={{ borderBottom: "1px solid #dcdcdc", cursor: "pointer" }}
                                        onClick={() => handleUserClick(user)}
                                    >
                                        <span>{user.user_name}</span>
                                    </div>
                                ))
                            ) : (
                                <p className="dropdown-item text-muted">No results found</p>
                            )}
                        </SimpleBar>
                    </div>
                )}
            </form>

            {/* Modal to show user details */}
            <Modal
                show={showUserModal}
                onHide={() => setShowUserModal(false)}
                centered
                dialogClassName="custom-modal-width"
            >
                <Modal.Header closeButton style={{ borderBottom: "1px solid #eaeaea", paddingBottom: "10px" }}>
                    <Modal.Title>User Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UserDetailsModal
                        show={showUserModal}
                        onHide={() => setShowUserModal(false)}
                        selectedUser={selectedUser}
                        userDetails={{
                            username: "vicky",
                            accountType: "User",
                            general: 5520,
                            exposure: 820,
                            creditReference: 0,
                            userLocks: [
                                { masterName: "placeagent", userAct: true, betActive: true },
                                { masterName: "bubble", userAct: true, betActive: false }
                            ],
                            gameLock: {
                                sno: 1,
                                masterName: "lcbook247-prime",
                                betLock: true,
                                eventName: "Pakistan Super League"
                            },
                            matchTitle: "Mumbai Indians v Royal Challengers Bengaluru",
                            matchTime: "07/04/2025 19:30:00",
                            matchInfo: "6 over runs MI(MI vs RCB)adv",
                            matchAmount: "-100"
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowUserModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
};

export default SearchOption;
